import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
        AlertDialog,
        AlertDialogAction,
        AlertDialogCancel,
        AlertDialogContent,
        AlertDialogDescription,
        AlertDialogFooter,
        AlertDialogHeader,
        AlertDialogTitle,
    } from '@/components/ui/alert-dialog';
    import { ref } from 'vue';
    import { toast } from 'vue-sonner';
    import { useI18n } from 'vue-i18n';
    import { useMutation } from '@tanstack/vue-query';
    import { useVoucherStore } from '@/stores/voucher';
    import axios from 'axios';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'VoucherStatementUploadAlertDialog',
  emits: ["delete-statements"],
  setup(__props, { emit: __emit }) {

    const { t } = useI18n();

    const voucherStore = useVoucherStore();

    const accounts = ref<any[]>([]);

    const defineEmit = __emit;

    const { mutate, isPending } = useMutation({
        mutationFn: (formData: { accounts: any[] }) =>
            axios.post(route('v2.voucher.admin.statement.delete'), formData),
        onSuccess: (data) => {
            console.log(data);
        },
        onError: (error: any) => {
            toast.error(error.response.data.message || t('forms.system_error'));
        },
    });

    function deleteStatements() {
        defineEmit('delete-statements');
        // mutate({
        //     accounts: accounts.value,
        // });
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(AlertDialog), {
    open: _unref(voucherStore).statementUploadAlertOpen,
    "onUpdate:open": _cache[0] || (_cache[0] = (value) => _unref(voucherStore).toggleStatementUploadAlertModal(value))
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(AlertDialogContent), { class: "sm:max-w-md" }, {
        default: _withCtx(() => [
          _createVNode(_unref(AlertDialogHeader), null, {
            default: _withCtx(() => [
              _createVNode(_unref(AlertDialogTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('vouchers.js.uploads_processing_title')), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(AlertDialogDescription), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('vouchers.js.uploads_processing_content')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(AlertDialogFooter), null, {
            default: _withCtx(() => [
              _createVNode(_unref(AlertDialogCancel), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('forms.no')), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(AlertDialogAction), {
                variant: "default",
                onClick: deleteStatements
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('forms.yes')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})